import { useEffect } from 'react'
import { useResourceLocationSender } from '../hooks/useResourceLocationSender'
import { useLocationTrackingDebug } from '../contexts/LocationTrackingDebugContext'

/**
 * Global location tracker – runs app-wide (mounted once in App.tsx).
 *
 * Location is ALWAYS ON when the user is signed in and has a business.
 * No settings (e.g. map_view_enabled) – app starts, location works.
 * Uses Transistorsoft plugin on native so tracking continues in background/closed.
 */
export default function GlobalLocationTracker() {
  const { setLocationDebugStatus } = useLocationTrackingDebug()
  const { locationDebugStatus } = useResourceLocationSender({ updateInterval: 2 })

  useEffect(() => {
    setLocationDebugStatus(locationDebugStatus)
  }, [locationDebugStatus, setLocationDebugStatus])

  return null
}
